import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";

import { Pagination } from "swiper/modules";
import { Box, Typography, createTheme, ThemeProvider, useMediaQuery } from "@mui/material";

import img1 from "../../../assets/images/workshop/img1.webp";
import img3 from "../../../assets/images/workshop/img3.webp";
import img2 from "../../../assets/images/workshop/img2.webp";
import img4 from "../../../assets/images/workshop/img4.webp";
import img5 from "../../../assets/images/workshop/img5.webp";
// Define custom breakpoints (same as original)
const customTheme = createTheme({
  breakpoints: {
    values: {
      mobile: 0,
      tablet: 768,
      desktop: 1024,
    },
  },
});

// Sample images array
const sampleImages = [
    { id: 1, imageUrl: img1 },
    { id: 2, imageUrl: img2},
    { id: 3, imageUrl: img3 },
    { id: 4, imageUrl: img4 },
    { id: 5, imageUrl: img5 },
  ];

const ImageCard = ({ image }) => (
  <Box
    sx={{
      backgroundColor: "#EB6502",
      borderRadius: 2,
      overflow: "hidden",
      maxWidth: 280,
      mx: "auto",
      height: 320,
      display: "flex",
      flexDirection: "column",
    }}
  >
    <Box 
      sx={{ 
        height: "100%", 
        width: "100%",
        overflow: "hidden"
      }}
    >
      <img 
        src={image.imageUrl} 
        alt="Workshop image" 
        style={{ 
          width: "100%", 
          height: "100%", 
          objectFit: "cover" 
        }} 
      />
    </Box>
  </Box>
);

const ImageSlider = ({ sectionTitle = "Gallery", images }) => {
  // UseMediaQuery to control Swiper slides per view
  const isMobile = useMediaQuery(customTheme.breakpoints.down("tablet")); // < 768px
  const isTablet = useMediaQuery(customTheme.breakpoints.between("tablet", "desktop")); // 768px - 1024px
  const isDesktop = useMediaQuery(customTheme.breakpoints.up("desktop")); // ≥ S1024px
  
  // Use provided images or fall back to sample images
  const displayImages = images || sampleImages;

  return (
    <ThemeProvider theme={customTheme}>
      <Box sx={{ padding: { mobile: 2, tablet: 3, desktop: 4 }, margin: { mobile: 2, tablet: 3 }, position: "relative" }}>
        <Typography variant="h4" sx={{ textAlign: "left", marginBottom: "32px", fontWeight: 700 }}>
          {sectionTitle}
        </Typography>

        <Swiper
          modules={[Pagination]}
          spaceBetween={10}
          slidesPerView={isMobile ? 1.2 : isTablet ? 2.5 : 5} // Responsive slides per view
          grabCursor={true}
          pagination={{ 
            clickable: true,
            el: '.swiper-pagination'
          }}
        >
          {displayImages.map((image) => (
            <SwiperSlide key={image.id}>
              <ImageCard image={image} />
            </SwiperSlide>
          ))}
        </Swiper>
        <Box className="swiper-pagination" sx={{ marginTop: "30px" }}></Box>
      </Box>
    </ThemeProvider>
  );
};

export default ImageSlider;